import styled, { css } from 'styled-components'

import { mediaMinTablet } from '@root/shared/ui-kit'

import type { PremiumMeta } from '@root/entities/premium'

type Props = {
  product: PremiumMeta.PremiumProduct
}

const PRODUCT_COLOR_MAP: Record<PremiumMeta.PremiumProduct, string> = {
  subscription: 'var(--subscriptionGradientTo-9)',
  boosters: 'var(--boostGradientTo-9)',
}

export const ScreenGlowing: React.FC<Props> = ({ product }) => (
  <Root $product={product}>
    <GlowingCorner />
    <GlowingCenter />
  </Root>
)

const Root = styled.div<{
  $product: PremiumMeta.PremiumProduct
}>`
  --light-gradient: ${({ $product }) =>
    $product === 'subscription'
      ? 'var(--subscriptionGradientFrom-9)'
      : 'var(--boostGradientFrom-9)'};
  --dark-gradient: ${({ $product }) => PRODUCT_COLOR_MAP[$product]};

  position: absolute;
  width: 100%;
  height: 300px;
  left: 0;
  bottom: 0;
  pointer-events: none;

  ${mediaMinTablet(css`
    height: 70%;
  `)}
`

const GlowingCenter = styled.span`
  background-image: radial-gradient(
    60% 300px at 50px 90%,
    rgb(from var(--light-gradient) r g b / 0.34) 0%,
    transparent 100%
  );
  position: absolute;
  width: 100%;
  height: 300px;
  left: 0;
  bottom: 0;
  opacity: 0.8;

  ${mediaMinTablet(css`
    display: none;
  `)}
`

const GlowingCorner = styled.span`
  background-image: radial-gradient(
    40% 170px at 210px 110%,
    rgb(from var(--dark-gradient) r g b / 0.81) 0%,
    transparent 100%
  );
  position: absolute;
  width: 100%;
  height: 300px;
  left: 0;
  bottom: 0;
  opacity: 0.6;

  ${mediaMinTablet(css`
    height: 100%;

    background-image: radial-gradient(
      70% 50% at 0% 100%,
      rgb(from var(--dark-gradient) r g b / 0.5) 0%,
      transparent 100%
    );
  `)}
`
